import PhysicalItemsLog from "./PhysicalItemsLog.vue";
export default PhysicalItemsLog;
